export default "09c7429408c624b9.ttf"